// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".src-Customer-Survey-screens-Components-EditQuestionCard-OpenTypeField-Style__textarea--tW3gf{border:0;margin:0;padding:.2em 0;appearance:none;background:none;color:#303640;border-radius:0;line-height:1.4;border-bottom:1px solid rgba(0,0,0,.15);min-height:3em;width:100%}.src-Customer-Survey-screens-Components-EditQuestionCard-OpenTypeField-Style__textarea--tW3gf:focus{border-bottom:1px solid #005cdb}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"textarea": "src-Customer-Survey-screens-Components-EditQuestionCard-OpenTypeField-Style__textarea--tW3gf"
};
export default ___CSS_LOADER_EXPORT___;
